import { render } from "./TargetScene.vue?vue&type=template&id=d7d0ecf4&scoped=true"
import script from "./TargetScene.vue?vue&type=script&lang=js"
export * from "./TargetScene.vue?vue&type=script&lang=js"

import "./TargetScene.vue?vue&type=style&index=0&id=d7d0ecf4&scoped=true&lang=css"

import exportComponent from "C:\\sw\\ar-unity-renderer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d0ecf4"]])

export default __exports__